import i18n from 'i18next';

import sessionStore from '../stores/SessionStore';

export const checkAndSetLanguage = () => {
  const { user } = sessionStore;
  // Prefer user preference; else last selected in localStorage; else 'en'
  const stored = (typeof window !== 'undefined' && localStorage.getItem('i18nextLng')) || undefined;
  const preferredLanguage = (user?.preferred_language || stored || 'en').toString();

  if (i18n.language !== preferredLanguage) {
    i18n.changeLanguage(preferredLanguage);
  }
};
